module.exports = __webpack_public_path__ + "img/device-comment.4b9aa407.svg";